var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCohortTracker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.103,
    height: 42.497,
    viewBox: "0 0 41.103 42.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.325,18.432c.579-.951,1.626-1.585,2.82-1.585,1.823,0,3.3,1.478,3.3,3.3s-1.478,3.3-3.3,3.3c-1.127,0-2.123-.565-2.718-1.428",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.144,18.772c.054-.117.114-.231.181-.341",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.287,24.282c.825-.528,1.806-.835,2.858-.835,2.931,0,5.308,2.376,5.308,5.308,0,.013-.004.025-.004.039h-6.465",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.874,18.6c-.555-1.043-1.652-1.753-2.916-1.753-1.823,0-3.3,1.478-3.3,3.3s1.478,3.3,3.3,3.3c1.139,0,2.144-.577,2.737-1.455",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.654,28.794c0-.013-.004-.025-.004-.039,0-2.932,2.377-5.308,5.308-5.308,1.052,0,2.033.306,2.858.835",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 21.01,
    y1: 0.65,
    x2: 21.01,
    y2: 3.793,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.752,
    y1: 3.908,
    x2: 16.277,
    y2: 6.433,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.274,
    y1: 3.908,
    x2: 25.749,
    y2: 6.433,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.01,
    y1: 6.572,
    x2: 21.01,
    y2: 6.632,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 20.552,
    cy: 21.437,
    r: 8.637,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.551,
    cy: 20.037,
    r: 3.436,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.942,27.78c-.555-2.466-2.758-4.308-5.391-4.308-2.617,0-4.81,1.82-5.381,4.263",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.608,27.741L1.84,36.508c-1.217,1.217-1.217,3.209,0,4.426,1.217,1.217,3.209,1.217,4.426,0l8.984-8.984c-1.902-.961-3.505-2.42-4.642-4.209Z",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25,31.95c1.595.806,3.392,1.271,5.302,1.271,6.508,0,11.783-5.275,11.783-11.783s-5.275-11.783-11.783-11.783-11.783,5.275-11.783,11.783c0,2.321.681,4.479,1.839,6.303",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCohortTracker);
export default __webpack_public_path__ + "static/media/Cohort-Tracker.c687c613.svg";
export { ForwardRef as ReactComponent };